// extracted by mini-css-extract-plugin
export default {"container":"individualSearchResults_container__90xnR","error":"individualSearchResults_error__ffEkq","message":"individualSearchResults_message__Y4zje"};